module.exports = __WEBPACK_EXTERNAL_MODULE_80__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 80
// module chunks = 0